"use client"

import { type LucideIcon } from "lucide-react"
import Link from 'next/link'

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"

import ClientOnly from '@/components/client-only'
import { useTranslation } from 'react-i18next'

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    icon?: LucideIcon
    isActive?: boolean
    items?: {
      title: string
      url: string
    }[]
  }[]
}) {
  const { t } = useTranslation()
  const { setOpenMobile } = useSidebar()

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Dashboard</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) =>
          <SidebarMenuItem
            key={t(item.title)}
          >
            <Link href={item.url} onClick={() => { setOpenMobile(false) }}>
              <SidebarMenuButton isActive={item.isActive} tooltip={t(item.title)}>
                {item.icon && <item.icon strokeWidth={item.isActive ? 3 : 2} />}
                <ClientOnly fallback={
                  <span className={item.isActive ? "font-bold" : "font-normal"} style={{ opacity: 0 }}>
                    {item.title}
                  </span>
                }>
                  <span className={item.isActive ? "font-bold" : "font-normal"}>
                    {t(item.title)}
                  </span>
                </ClientOnly>
              </SidebarMenuButton>
            </Link>
          </SidebarMenuItem>
        )}
      </SidebarMenu>
    </SidebarGroup>
  )
}
